module.exports = __webpack_public_path__ + "static/media/kota-kanan.6ad91a7b.svg";